import React from 'react';
import Mediatek from 'components/Mediatek';

const FrontMediatek = () => {
    return <Mediatek title={ 'Медиатека' } description={
        `Видео и подкасты, которые основатель проекта «Ответ» Вероника Сидорова записывает с другими психотерапевтами, — 
        это уникальная база материалов по самым разным темам. Обращаясь к этим записям, вы сможете получить 
        профессиональное мнение по важному для вас вопросу и получить удовольствие от интересного разговора.`
    }/>;
};

export default FrontMediatek;

